import e from "react";
var n = 0;

function r(r) {
  var s = r.match,
      c = s.map(function (e) {
    return e[0];
  }),
      i = function (n) {
    var r = "undefined" == typeof window,
        t = n.slice(0, -1);
    "default" !== n[n.length - 1] && console.warn("last media query should be 'default'");
    var a = e.useState(0)[1],
        l = r ? [] : t.map(function (e) {
      return window.matchMedia(e);
    });
    e.useEffect(function () {
      var e = function e() {
        return a(function (e) {
          return e + 1;
        });
      };

      return l.forEach(function (n) {
        return n.addListener(e);
      }), function () {
        return l.forEach(function (n) {
          return n.removeListener(e);
        });
      };
    }, []);
    var s = l.findIndex(function (e) {
      return e.matches;
    });
    return {
      isServer: r,
      matchedIndex: s < 0 ? n.length - 1 : s
    };
  }(c),
      u = i.isServer,
      o = i.matchedIndex,
      m = u ? "ssmq-" + n++ : "";

  return u ? e.createElement(e.Fragment, null, e.createElement("style", {
    className: m,
    dangerouslySetInnerHTML: {
      __html: t(c, m)
    }
  }), s.map(function (n) {
    var r = n[0],
        t = n[1];
    return e.createElement("div", {
      key: r,
      className: m + " " + l(r)
    }, t);
  }), e.createElement("script", {
    className: m,
    dangerouslySetInnerHTML: {
      __html: a(s, m)
    }
  })) : e.createElement(e.Fragment, null, e.createElement("div", null, s[o][1]));
}

function t(e, n) {
  return e.slice().reverse().map(function (e) {
    var r = "." + n + "." + l(e) + "{display:block}",
        t = "." + n + ":not(." + l(e) + "){display: none;}";
    return "default" === e ? "" + r + t : "@media " + e + "{" + r + t + "}";
  }).join("\n");
}

function a(e, n) {
  var r = e.map(function (e) {
    return e[0];
  }),
      t = r.map(l);
  return "(function() {\n  var qs = " + JSON.stringify(r) + ";\n  var clss = " + JSON.stringify(t) + ';\n  var mainCls = "' + n + '";\n\n  var scrEls = document.getElementsByTagName("script");\n  var scrEl = scrEls[scrEls.length - 1];\n  var parent = scrEl.parentNode;\n\n  var el = null;\n  for (var i = 0; i < qs.length - 1; i++) {\n    if (window.matchMedia(qs[i]).matches) {\n      el = parent.querySelector(":scope > ." + mainCls + "." + clss[i]);\n      break;\n    }\n  }\n  if (!el) {\n    var defaultClass = clss.pop();\n    el = parent.querySelector(":scope > ." + mainCls + "." + defaultClass);\n  }\n  el.removeAttribute("class");\n\n  parent.querySelectorAll(":scope > ." + mainCls).forEach(function (e) {\n    parent.removeChild(e);\n  });\n})();';
}

function l(e) {
  return "ssmq-" + e.replace(/[!\"#$%&'\(\)\*\+,\.\/:;<=>\?\@\[\\\]\^`\{\|\}~\s]/g, "").toLowerCase();
}

export { r as Swap };